<template>
  <section class="companies-section" :class="{ active: active }" @click="active = !active">
    <div class="companies-section--wrapper">
      <div class="companies-section--logo">
        <img :src="organization.logo" />
      </div>
      <div>
        <b class="companies-section--name">{{ organization.name }}</b>
        <div class="companies-section--title">{{ organization.sector ? $options.filters.translate(organization.sector.name) : "" }}</div>
      </div>
      <div class="companies-section--arrow">
        <img src="@/assets/images/arrow-down.png" />
      </div>
    </div>
    <nav class="companies-section--nav">
      <div @click="selectOrganizationAndGo(organization, '/organization')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('organization.panel')">
          <i class="iconoir-cube-hole"></i>
        </div>
      </div>
      <div v-if="hasOrganizationAccessableForProduct(organization, 'RISK')" @click="selectOrganizationAndGo(organization, '/risk/dashboard')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('product.risk.product')">
          <img src="/icons/risk.svg" alt="" />
        </div>
      </div>
      <div v-if="hasOrganizationAccessableForProduct(organization, 'GDPR')" @click="selectOrganizationAndGo(organization, '/gdpr/roadmap')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('product.gdpr.product')">
          <img src="/icons/gdpr.svg" alt="" />
        </div>
      </div>
      <div v-if="hasOrganizationAccessableForProduct(organization, 'KVKK')" @click="selectOrganizationAndGo(organization, '/kvkk/roadmap')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('product.kvkk.product')">
          <img src="/icons/kvkk.svg" alt="" />
        </div>
      </div>
      <div v-if="hasOrganizationAccessableForProduct(organization, 'DDO')" @click="selectOrganizationAndGo(organization, '/ddo/roadmap')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('product.ddo.product')">
          <img src="/icons/ddo.svg" alt="" />
        </div>
      </div>
      <div v-if="hasOrganizationAccessableForProduct(organization, 'BGYS')" @click="selectOrganizationAndGo(organization, '/bgys/roadmap')">
        <div class="companies-section--nav-item" v-b-tooltip.hover.bottom="{ variant: 'main' }" :title="$t('product.bgys.product')">
          <img src="/icons/bgys.svg" alt="" />
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  props: ["organization"],
  data() {
    return {
      active: false,
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.companies-section {
  font-family: "Roboto";
  background: #f8f8fb;
  border-bottom: 1px solid #eaebf1;
  padding: 1.25rem;
  cursor: pointer;

  &.active {
    .companies-section--arrow {
      transform: rotate(-90deg);
    }

    .companies-section--nav {
      margin-top: 1rem;
      height: auto;
    }
  }
}

.companies-section--logo {
  margin-right: 0.6rem;
  width: 1.75rem;
}

.companies-section--wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.companies-section--name {
  color: #383a55;
  font-size: 1.125rem;
  font-weight: 500;
}

.companies-section--title {
  color: #90979c;
  font-size: 0.875rem;
}

.companies-section--arrow {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  transition: 0.4s;
}

.companies-section--nav {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-left: calc(1.75rem + 0.6rem);
  margin-top: 0;
  height: 0;
  overflow: hidden;
  transition: 0.4s;
}

.companies-section--nav-item {
  display: grid;
  place-items: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.625rem;
  border: 1px solid #eaebf1;
  background: #fff;
  transition: 0.4s;

  i {
    font-size: 1.125rem;
    color: #e1e2eb;
    transition: 0.4s;
  }

  img {
    width: 1.125rem;
    transition: 0.4s;
  }

  &:hover {
    border-color: #ff7c48;

    i {
      color: #ff7c48;
    }
  }
}
</style>
